<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <search-bar v-model="formData" @search="handleSearch"></search-bar>
      </el-header>
      <el-main ref="main" style="position: relative;">
        <div style="position: absolute;top: 0;right: 10px;height: 40px;line-height: 40px;z-index: 1000;" v-if="activeName!=='word'">
          <el-button type="primary" size="mini" @click.capture="expandAll">全部展开</el-button>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="说辞表" name="word"></el-tab-pane>
          <el-tab-pane label="信息表" name="message"></el-tab-pane>
          <el-tab-pane label="bom表" name="bom"></el-tab-pane>

        </el-tabs>
        <word-sheet :tableHeight="tableHeight" v-if="activeName === 'word'" ref="word"></word-sheet>
        <!-- bom表 -->
        <message-sheet :tableHeight="tableHeight" :dataType="1" v-if="activeName === 'bom'" ref="bom" key="bom"></message-sheet>
        <!-- 信息表 -->
        <message-sheet :tableHeight="tableHeight" :dataType="2" v-if="activeName === 'message'" ref="message" key="message"></message-sheet>
        <!-- <bom-sheet :tableHeight="tableHeight" v-if="activeName === 'bom'" ref="bom"></bom-sheet> -->
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import searchBar from './search'

  import wordSheet from './word-sheet/word-sheet'
  import messageSheet from './message-sheet/message-sheet'
  import bomSheet from './bom-sheet/bom-sheet'
  import pagePathMixin from '@/utils/page-path-mixin'
  export default {
    components: {
      searchBar,
      wordSheet,
      messageSheet,
      bomSheet
    },
    mixins: [pagePathMixin],
    data() {
      return {
        activeName: 'word',
        tableHeight: 0,
        formData: {}
      }
    },
    watch:{
      activeName(val){
        if(val==='message'){
          this.$refs['message'] && this.$refs['message'].expand(0);
        }else if(val==='bom'){
          this.$refs['bom'] && this.$refs['bom'].expand(0);
        }
      }
    },

    mounted() {
      this.tableHeight = this.$refs['wrapper'].offsetHeight - 175;
    },
    methods: {
      handleSearch(data) {
        this.$refs['word'] && this.$refs['word'].handleSearch(data);
        this.$refs['message'] && this.$refs['message'].handleSearch(data);
        this.$refs['bom'] && this.$refs['bom'].handleSearch(data);
      },
      expandAll(){
        if(this.activeName==='message'){
          this.$refs['message'] && this.$refs['message'].expand(1);
        }else if(this.activeName==='bom'){
          this.$refs['bom'] && this.$refs['bom'].expand(1);
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .container
    margin 5px
    width auto
    height calc(100% - 10px)
    box-sizing border-box
    border-radius 5px
    position relative
  >>> .el-header
    background #ffffff
    padding 0 0 0 8px
    margin-bottom 5px !important
    position relative
    border-radius 5px
  >>> .el-main
    padding 5px 8px
    background #ffffff
    border-radius 5px

  >>> .el-tabs__header
    margin-bottom 0
</style>
